export default __webpack_public_path__ + "static/media/Story-book.2d708495.png";